import { render } from "./detial.vue?vue&type=template&id=6f1bee52&scoped=true"
import script from "./detial.vue?vue&type=script&lang=js"
export * from "./detial.vue?vue&type=script&lang=js"

import "./detial.vue?vue&type=style&index=0&id=6f1bee52&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1bee52"]])

export default __exports__